.list {
  display: grid;
  gap: var(--pgm-sys-spacing-8);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  align-items: center;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-3);
}

.link {
  min-width: 0;
}

@media (max-width: 899.98px) {
  .list {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--pgm-sys-spacing-4);
  }
}
